import { Button } from '@/components/ui/Button'
import { Link } from 'react-router-dom'

const footerLinks = [
  {
    title: 'Enlaces',
    links: [
      { name: 'Inicio', href: '/' },
      { name: 'Funcionalidades', href: '/#features' },
      { name: 'Proceso', href: '/#howitworks' },
      { name: 'Precios', href: '/#pricing' },
      { name: 'Testimonios', href: '/#testimonials' },
      { name: 'Contacto', href: '/#contact' }
    ]
  },
  {
    title: 'Legal',
    links: [
      { name: 'Política de Privacidad', href: '/privacy' },
      { name: 'Términos y Condiciones', href: '/terms' }
    ]
  }
]

/**
 * Footer component for the landing page
 * Includes navigation links and company information
 */
export function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-300 pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-12 border-b border-gray-800 pb-12">
          {/* Logo y descripción */}
          <div className="flex-1 min-w-[220px] flex flex-col gap-4">
            <div className="flex items-center gap-2">
              {/* Inline SVG as logo */}
              <svg className="h-8 w-8 text-white" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="16" fill="currentColor" />
                <path d="M10 17l4-4 4 4 4-4" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <Link to="/" className="text-2xl font-bold text-white hover:text-primary-400 transition-colors">
                Validea
              </Link>
            </div>
            <p className="text-gray-400 text-sm max-w-xs mt-2">
              Gestiona la validación de ideas y el progreso de tu MVP, todo en una sola plataforma.
            </p>
            <a 
              href="#contact"
              className="mt-4 w-fit bg-primary-600 hover:bg-primary-500 text-white font-semibold px-6 py-2 rounded-full shadow-lg transition-colors"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contáctanos
            </a>
          </div>

          {/* Enlaces */}
          <div className="flex-1 grid grid-cols-2 gap-8 md:max-w-sm">
            {footerLinks.map((section) => (
              <div key={section.title}>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      {link.href.startsWith('/') && !link.href.includes('#') ? (
                        <Link
                          to={link.href}
                          className="text-sm text-gray-300 hover:text-primary-400 transition-colors"
                        >
                          {link.name}
                        </Link>
                      ) : (
                        <a
                          href={link.href}
                          className="text-sm text-gray-300 hover:text-primary-400 transition-colors"
                          onClick={(e) => {
                            if (link.href.includes('#')) {
                              e.preventDefault();
                              const id = link.href.split('#')[1];
                              document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
                            }
                          }}
                        >
                          {link.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Legal y derechos */}
        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-gray-500">
          <div className="flex flex-col md:flex-row md:items-center gap-2">
            <span>©2025 Validea. Todos los derechos reservados.</span>
            <span className="hidden md:inline">·</span>
            <span>
              Desarrollado por{' '}
              <a 
                href="https://alineatec.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary-400 hover:text-primary-300 transition-colors"
              >
                AlineaTec
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
} 